import useRequest, { IDataRequest } from '@hooks/useRequest';
import { EnumEmpresa } from '@model/Empresa';
import ILinha from '@model/Linha';
import { EnumOperadora } from '@model/Operadora';
import React from 'react';

export interface ILinhaFilter {
    ddd?: string
    numeroSemMascara?: string
    empresaId?: EnumEmpresa
    operadoraId?: EnumOperadora
    linhaEmpresa?: string
    numeroContrato?: string
    whatsappEnvio?: number
    disponibilidade?: string
}

export interface IObterParaAtribuirRequest {
    numeroSemMascara: string
}

const controller = "/Linha";

export function useLinhaService () {
    const _request = useRequest();

    const listar = React.useCallback((request: IDataRequest<ILinhaFilter>) => {
        return _request.getData<ILinha[]>(`${controller}/Listar/`, request);
    }, [_request]);

    const editar = React.useCallback((linhaId: number, request: ILinha) => {
        return _request.post<ILinha>(`${controller}/Editar/${linhaId}`, request);
    }, [_request]);

    const carregar = React.useCallback((linhaId: number) => {
        return _request.get<ILinha>(`${controller}/Carregar/${linhaId}`);
    }, [_request]);

    const carregarPorNumero = React.useCallback((numero: string) => {
        return _request.get<ILinha | null>(`${controller}/CarregarPorNumero/${numero}`);
    }, [_request]);

    const obterParaAtribuir = React.useCallback((request: IObterParaAtribuirRequest) => {
        return _request.get<ILinha | null>(`${controller}/ObterParaAtribuir`, {
            params: request
        });
    }, [_request]);

    const listarNumerosContrato = React.useCallback(() => {
        return _request.get<string[]>(`${controller}/listarNumerosContrato`);
    }, [_request]);

    return React.useMemo(() => ({
        carregarPorNumero, listar, editar, carregar, obterParaAtribuir, listarNumerosContrato
    }), [carregarPorNumero, listar, editar, carregar, obterParaAtribuir, listarNumerosContrato]);
}